'use client';

import { memo } from 'react';

import { H4, P } from '@/components/shared/Typography';
import { cn } from '@/lib/utils/cn';
import { formatNumberWithCommasAndDecimals } from '@/lib/utils/formatNumberWithCommasAndDecimals';

interface I_TokenStatsItemProps {
  label: string;
  value: string;
  decimals?: number;
  className?: string;
}

export const TokenStatsItem = memo(
  ({ label, value, decimals, className = '' }: I_TokenStatsItemProps) => (
    <div className={cn('md:mb-5', className)}>
      <P className="text-muted text-sm font-normal leading-tight">{label}</P>
      <H4 className="text-xl font-semibold leading-7 break-all">
        {formatNumberWithCommasAndDecimals(
          parseFloat(value).toLocaleString(),
          decimals
        )}
      </H4>
    </div>
  )
);

TokenStatsItem.displayName = 'TokenStatsItem';
